/* Cart drawer add-ons for Dawn. "You may also like" recommendations keyed to a cart product. */
(function () {
  if (customElements.get('cart-recommendations')) return;

  class CartRecommendations extends HTMLElement {
    connectedCallback() {
      const pid = this.dataset.productId;
      this.results = this.querySelector('[data-cdr-results]');
      if (!pid || !this.results) {
        this.hidden = true;
        return;
      }
      this.limit = this.dataset.limit || '6';
      this.cartCount = this.dataset.cartCount || '';   // re-fetch when cart items change
      this.load(pid);
    }

    recUrl(pid) {
      const base = (window.routes && window.routes.product_recommendations_url) || '/recommendations/products';
      return (
        base +
        '?section_id=cart-recommendations&intent=related&limit=' +
        encodeURIComponent(this.limit) +
        '&product_id=' +
        encodeURIComponent(pid)
      );
    }

    load(pid) {
      const key = pid + ':' + this.limit + ':' + this.cartCount;
      if (CartRecommendations.cache[key] !== undefined) {
        this.render(CartRecommendations.cache[key]);
        return;
      }
      fetch(this.recUrl(pid))
        .then((response) => response.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const list = doc.querySelector('.cdr-list');
          const html = list ? list.outerHTML : '';
          CartRecommendations.cache[key] = html;
          this.render(html);
        })
        .catch(() => {
          this.hidden = true;
        });
    }

    render(html) {
      this.results.innerHTML = html || '';
      this.hidden = !this.querySelector('.uc-card');   // hide only when there are genuinely no cards
    }

    onClick(event) {
      const btn = event.target.closest('[data-cdr-add]');
      if (!btn || btn.disabled) return;
      event.preventDefault();

      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      const drawer = document.querySelector('cart-drawer');
      const sections = drawer
        ? drawer.getSectionsToRender().map((section) => section.id)
        : ['cart-drawer', 'cart-icon-bubble'];

      btn.classList.add('is-loading');
      btn.disabled = true;

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: sections,
          sections_url: window.location.pathname,
        }),
      })
        .then((response) => response.json())
        .then((parsed) => {
          if (parsed.status) {
            btn.classList.remove('is-loading');
            btn.disabled = false;
            return;
          }
          if (drawer && parsed.sections) {
            drawer.renderContents(parsed);
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(() => {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
    }
  }

  CartRecommendations.cache = {};
  customElements.define('cart-recommendations', CartRecommendations);
})();
